import { render, staticRenderFns } from "./bookNote.vue?vue&type=template&id=3ea4aa25&scoped=true"
import script from "./bookNote.vue?vue&type=script&lang=js"
export * from "./bookNote.vue?vue&type=script&lang=js"
import style0 from "./bookNote.vue?vue&type=style&index=0&id=3ea4aa25&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea4aa25",
  null
  
)

export default component.exports